import { Box, Container, Grid, Stack } from "@mui/material";
import VSNLoader from "../../shared/VSNLoader";
import VSNProgressiveImage from "../../shared/VSNProgressiveImage";
import VSNTypography from "../../shared/VSNTypography";
import { LearningStyle } from "./LearningStyle";
import videoImage from "../../assets/learning/video.webp";

const ArticleReader = ({ data, loader }) => {
  const classes = LearningStyle();

  if (loader) {
    return <VSNLoader variant="transParent" />;
  }

  return (
    <Container maxWidth="xl" p={{ sm: 4, xs: 2 }}>
      {data ? (
        <>
          <Stack gap={1} py={2} maxWidth="lg" mx="auto">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <VSNTypography
                fontSize={{ md: 40, sm: 30, xs: 24 }}
                fontWeight={700}
              >
                {data?.title ?? ""}
              </VSNTypography>
              {/* <IconButton className={classes.addIcon}>
                <AddIcon fontSize="large" />
              </IconButton> */}
            </Stack>

            <VSNTypography
              sx={{ fontWeight: "400" }}
              fontSize={{ md: 24, sm: 20, xs: 18 }}
            >
              By {data?.instructor ?? ""}
            </VSNTypography>
            <VSNTypography
              sx={{ fontWeight: "400" }}
              color="text.secondary"
              mt={-1}
            >
              {data?.content_duration ?? ""}
            </VSNTypography>
            <Stack direction="row" gap={1} flexWrap="wrap">
              <VSNTypography
                mr={2}
                mt={1.3}
                sx={{ flex: "none" }}
                fontSize={{ md: 20, sm: 18, xs: 16 }}
              >
                Topics Covered:
              </VSNTypography>

              {data?.tags?.map((tag, index) => (
                <VSNTypography
                  key={index}
                  sx={{
                    padding: "8px",
                    backgroundColor: "#FEF6EE",
                    borderRadius: "8px",
                    fontWeight: 700,
                    color: "var(--secondary)",
                  }}
                >
                  {tag}
                </VSNTypography>
              ))}

              {/* <VSNButton variant="outlined" sx={{ px: 2, flex: "none" }}>
                Mark As Complete
              </VSNButton> */}
            </Stack>
          </Stack>

          <Stack maxWidth="1225px" maxHeight="690px" mx="auto" my={4}>
            <VSNProgressiveImage
              src={data?.link ?? data?.thumbnail}
              placeholder={videoImage}
              alt="book_cover"
              style={{
                borderRadius: "16px",
                objectFit: "cover",
                width: "100%",
                marginX: "auto",
                display: "block",
              }}
            />
          </Stack>

          <Box maxWidth="lg" mx="auto">
            <Grid container justifyContent="center">
              <Grid item sm={12} md={10} width="100%">
                <div
                  style={{ whiteSpace: "pre-line", wordWrap: "break-word" }}
                  className="html-content-moodle"
                  dangerouslySetInnerHTML={{ __html: data?.summary }}
                />
              </Grid>
            </Grid>
          </Box>

          {/* <Stack direction="row" justifyContent="end" mb={4}>
          <VSNButton variant="outlined" sx={{ px: 2, flex: "none" }}>
            Mark As Complete
          </VSNButton>
        </Stack> */}
        </>
      ) : (
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          py={10}
        >
          No data found
        </Stack>
      )}
    </Container>
  );
};

export default ArticleReader;
